'use strict';

const urlUtil = require('./urlUtil');
const isMargiela = document.body.dataset.sitebrand === "Margiela";

const $form = $('.js_search-content-form');
const $results = $('.js_search-content-results');
const $body = $('body');

/**
 * Append result item to result list
 * @param {Object} content - the model that contains the result item data
 */
function appendResult(content) {
  const resultLi = document.createElement('li');
  resultLi.classList.add('result-item-li');
  const result = document.createElement('a');
  result.classList.add('result-item');
  resultLi.classList.add('item');
  resultLi.setAttribute('role', "option");
  resultLi.setAttribute('id', content.id);
  result.setAttribute('href', content.helpUrl);
  result.textContent = content.name;
  resultLi.append(result);
  $results.append(resultLi);
}

/**
 * Append a message (result without link) to result list
 * @param {string} message - message content
 */
function appendMessage(message) {
  const result = document.createElement('span');
  result.classList.add('result-item');
  result.classList.add('result-message');
  if(isMargiela) {
    result.classList.add('mm-form-message');
    result.classList.add('-invalid');
    $results.removeClass('d-none');
    result.setAttribute('role','alert');
  }
  result.textContent = message;
  $results.append(result);
}

module.exports = {
  submit: function () {
    $form.on('submit', function (event) {
      event.preventDefault();
      $.spinner().start();
      const searchBarForm = event.currentTarget.closest('.mm-menu-search__bar');
      if(isMargiela) {
        searchBarForm || $form.classList.contains('order-tracking-form') ? searchBarForm.classList.remove('invalid-search') : null;
        $results.empty();
      }
      $results.removeClass('show');
      // let url = $form.attr('action');
      let url = event.currentTarget.closest('form').getAttribute('action');
      
      url = urlUtil.getUrlWithNewParameter('q', $form.find('input').val(), url);
      if(!isMargiela || (searchBarForm && $form.find('input').val())) {
        $.getJSON(url, function (data) {
          $results.empty();
  
          if (data.contentSearch && data.contentSearch.contentCount) {
            let content;
            for (let i = 0; i < data.contentSearch.contents.length; i++) {
              content = data.contentSearch.contents[i];
              appendResult(content);
            }
            if(isMargiela) {
              $('#help-search-result-count').html(data.message);
              $('#help-search-result-count').attr('role', 'alert');
            }
          } else {
            if(isMargiela) {
              searchBarForm ? searchBarForm.classList.add('invalid-search') : null;
            }
            appendMessage(data.msgNoResults);
          }
  
          $.spinner().stop();

          // IBT-3495
          $results.removeClass('d-none');

          $results.addClass('show');
        });
      } else if(isMargiela && !$form.find('input').val()) {
        searchBarForm ? searchBarForm.classList.add('invalid-search') : null;
        appendMessage($('.mm-help-area-search-input-error').html());
      }
    });
  },
  autoClearResults: function () {
    $body.on('click', function () {
      const $target = $(event.target);
      if (!$target.parents('.js_search-content-results').length) {
        // User clicked outside results
        $results.removeClass('show');
      }
    });
  },
  searchButton: function () {
    $body.on('click', '.help-search-icon', function () {
      if ($form.get(0).checkValidity()) $form.trigger('submit');
    });
  },
  onRemoveSearchInput: function() {
    $body.on('keydown','.help-search-input', function(e) {
      if ((e.keyCode == 46 || e.keyCode == 8)) {
        $('.search-content-results.js_search-content-results').html('');
      }
    } )
  },
};
